import styles from './EmptyState.module.css';

export default function EmptyState({ emoji = '🔍', text = 'Nothing found.' }) {
  return (
    <div className={styles.wrap}>
      <span className={styles.emoji}>{emoji}</span>
      <p className={styles.text}>{text}</p>
    </div>
  );
}
